var React = require('react');

function PlaySmall2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.75 9L5 15V3L14.75 9Z","fill":"black"}));
}

PlaySmall2.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = PlaySmall2;

PlaySmall2.default = PlaySmall2;
